import React, { useRef } from "react";
import HomeBlueBackground from "../img/HomeBlueBackground.png";
import HomeBlueBackgroundDesktop from "../img/HomeBlueBackgroundDesktop.png";
import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import Funding from "../components/Home/Funding";
import HomeTitle from "../components/Home/HomeTitle";
import GetToKnowUs from "../components/Home/GetToKnowUs";
import Testimonies from "../components/Home/Testimonies";
import P5Commitment from "../components/Home/P5Commitment";
import LaborInsertion from "../components/Home/LaborInsertion";
import ProgrammingPath from "../components/Home/ProgrammingPath";
import ApplyNowButton from "../components/Buttons/ApplyNowButton";
import CodingPlatformRatings from "../components/CodingPlatformsRatings/CodingPlatformRatings";
import { useLocation } from "react-router-dom";
import useTranslation from "../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  div: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    overflow: "hidden",
  },
  box: {
    height: { xs: "633px", md: "800px" },
    width: "100vw",
    backgroundImage: {
      xs: `url(${HomeBlueBackground})`,
      md: `url(${HomeBlueBackgroundDesktop})`,
    },
    borderRadius: { xs: "0 0 40px 40px", md: "inherit" },
    backgroundRepeat: "no-repeat",
    backgroundSize: { xs: "cover", md: "100% 100%" },
    display: "flex",
    justifyContent: { xs: "center", md: "flex-start" },
    alignItems: "center",
    flexDirection: "column",
    color: theme.palette.white.main,
  },
  homeBox: {
    display: { xs: "flex" },
    justifyContent: { xs: "center" },
    alignItems: { xs: "center", md: "flex-start" },
    flexDirection: { xs: "column" },
    width: { md: "850px", lg: "1100px", xl: "1300px" },
  },
  ratingBox: { display: { md: "flex" }, mt: { md: "100px" } },
});

const Home = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const divRef = useRef(null);
  const { pathname } = useLocation();
  const { ratings } = useTranslation(pathname, "Home");

  return (
    <div>
      <Box sx={classes.div}>
        <Box sx={classes.box}>
          <Box sx={classes.homeBox}>
            <HomeTitle />
            <ApplyNowButton
              mb={isMobile ? "25px" : "-15px"}
              mt={!isMobile ? "40px" : "20px"}
            />
            <Box sx={classes.ratingBox}>
              <CodingPlatformRatings {...ratings[0]} />
              <CodingPlatformRatings {...ratings[1]} />
            </Box>
          </Box>
        </Box>
        <P5Commitment />
        <ProgrammingPath innerRef={divRef} />
        <Funding />
        <LaborInsertion innerRef={divRef} />
        <Testimonies />
        <GetToKnowUs />
      </Box>
    </div>
  );
};

export default Home;
